import {useContext} from "react";
import {CampaignsContext, PlacementFormDataContext} from "./CampaignsContext";

export const useCampaignsContext = () => useContext(CampaignsContext)
export const usePlacementFormDataContext = () => useContext(PlacementFormDataContext)